export default __webpack_public_path__ + "static/media/chPlaceholder.2b6e4ec5.png";